<template>
    <el-dialog
    title="学习记录"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="120rem">
    <div class="content-box">
        <div class="top-content-box">
            <p>{{ detail.userName }}</p>
            <p>{{ detail.className }}</p>
            <div class="hr"></div>
            <div class="top-item" style="margin-left: 1rem;">
                <p>学习时长</p>
                <p>{{ detail.studyTime||'/' }}</p>
            </div>
            <div class="top-item" style="margin-left: 3.5rem;">
                <p>最后学习时间</p>
                <p>{{ detail.finalStudyTime||'/' }}</p>
            </div>
            <div class="top-item" style="margin-left: 3.5rem;">
                <p>完成度</p>
                <p>{{ !detail.teachingUnitCount ? '' : parseFloat(((detail.completenessTeachingUnitCount || 0) / (detail.teachingUnitCount || 0) *100).toFixed(2))+'%' }}</p>
            </div>
        </div>
        <div class="table-content-box">
           <study-table ref="study_table" :openCourseId="openCourseId" :detail="detail" :courseInfo="courseInfo"></study-table>
        </div>
    </div>
    </el-dialog>
</template>

<script>
import StudyTable from './StudyTable.vue';
    export default {
  components: { StudyTable },
  props:['courseInfo','openCourseId'],
        data(){
            return {
                dialogVisible:false,
                detail:{},
            }
        },
        methods:{
            /**查看记录列表 */
            viewTrainList(){
                this.$nextTick(()=>{
                    let dom=this.$refs.study_table;
                    if(dom){
                        dom.pages.current=1;
                        dom.pageQueryCourseStudyCount();
                    }
                })
            },
        }
    }
</script>

<style lang="less" scoped>
/deep/.el-dialog__title{
    font-size: 16px;
    font-weight: 700;
    color: #334681;
}
/deep/.el-dialog{
    border-radius: 1rem;
}
.top-content-box{
    height: 6rem;
    background-color: #F3F7FC;
    display: flex;
    align-items: center;
    padding: 0 3.5rem;
    &> :nth-child(1){
        font-weight: 700;
        font-size: 16px;
    }
    &> :nth-child(2){
        margin-left: 1.5rem;
    }
    .hr{
        margin: 0 1.7rem;
        width: 1px;
        height: 2rem;
        background-color: #C2C7D9;
    }
}
.top-item{
    display: flex;
    &> :nth-child(2){
        margin-left: 1rem;
        color: var(--blue);
    }
}
.table-content-box{
    border-top:1px solid #EDF3F9;
    margin-top: 3rem;
    padding-top: 2.7rem;
    .box{
        margin-top: 3rem;
        height: 50rem;
    }
}
.table-title{
    font-weight: 700;
    margin-left: 3.5rem;
}
/deep/.el-table--border th {
    background-color: #F3F7FC !important;
}
/deep/.el-table--border, .el-table--group{
    border: none !important;
}
/deep/.el-table--border::after, .el-table--group::after{
    width: 0 !important;
}
/deep/.el-table{
    border-radius: 0 !important;
}
</style>